import ValueEditorTextProperty from "./ValueEditorTextProperty";

export default ValueEditorTextProperty;
export { ValueEditorTextProperty };
